import { Sensor } from '../api/models';

export type PcdCategory = 'new' | 'retained' | 'none';

export function categorizeSensorPcd(
  sensor: Sensor,
  lastPcdBundleUploadAt?: string | null
): PcdCategory {
  if (!sensor.pcdUrl) {
    return 'none';
  }
  if (!lastPcdBundleUploadAt) {
    return 'retained';
  }
  if (!sensor.pcdUpdatedAt) {
    // Legacy PCD uploaded before pcdUpdatedAt tracking was added.
    return 'retained';
  }
  const updatedAt = new Date(sensor.pcdUpdatedAt).getTime();
  const batchAt = new Date(lastPcdBundleUploadAt).getTime();
  // Same upload batch shares one timestamp; allow 1s slack for serialization skew.
  return updatedAt >= batchAt - 1000 ? 'new' : 'retained';
}

export const pcdCategoryLabel: Record<PcdCategory, string> = {
  new: 'New this batch',
  retained: 'Retained',
  none: 'No PCD',
};

export function formatComparisonVerdict(verdict?: 'aligned' | 'moved' | null): string {
  if (verdict === 'aligned') {
    return 'still aligned';
  }
  if (verdict === 'moved') {
    return 'moved — re-align';
  }
  return '';
}

export function sensorPcdTimestamp(sensor: Sensor): string | null {
  return sensor.pcdUpdatedAt ?? sensor.pcdComparison?.comparedAt ?? null;
}

export function formatPcdTimestamp(iso?: string | null): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
